import DataCenterValue from "./datacenter-value";
import ValueDisplay from "./value-display";
import type { RenderProps } from "./types";

export default function selectRenderer({
  obj,
  value,
  isOldValue,
}: RenderProps) {
  // Database options
  if (obj.config.options_type === "database") {
    // Multiplicity is inferred from the value shape rather than
    if (Array.isArray(value)) {
      return (
        <div className="flex gap-1">
          {(value as Array<string>).map((val, i, arr) => (
            <div key={val}>
              <DataCenterValue
                table_name={obj.config.data_center_table}
                column_name={obj.config.data_center_column}
                table_source={obj.config.source}
                value={val}
                oldValue={isOldValue}
              />
              {i < arr.length - 1 && <span className="text-body">, </span>}
            </div>
          ))}
        </div>
      );
    }
    return (
      <DataCenterValue
        table_name={obj.config.data_center_table}
        column_name={obj.config.data_center_column}
        table_source={obj.config.source}
        value={value as string}
        oldValue={isOldValue}
      />
    );
  }

  // Manual options
  if (Array.isArray(value)) {
    const values = value as Array<string>;
    const result = values
      .map(
        (val) =>
          obj.config.options.find((o: { value: string }) => o.value === val)
            ?.label ?? null,
      )
      .filter(Boolean);
    return (
      <ValueDisplay isOldValue={isOldValue}>{result.join(", ")}</ValueDisplay>
    );
  }

  const option = obj.config.options.find(
    (o: { value: string }) => o.value === value,
  );
  if (!option) {
    return <span className="text-on-disabled-quiet">Vacío</span>;
  }
  return <ValueDisplay isOldValue={isOldValue}>{option.label}</ValueDisplay>;
}
